import React, { useContext, useEffect, useState } from 'react';

import { useIonAlert } from '@ionic/react';

import {
  ContextDebugStruct,
  DebugStateStruct,
  IDebugProvider,
  roleType,
} from './interfaced';

export const useDebug = () => {
  return useContext(DebugContext);
};

export const DebugContext = React.createContext({} as ContextDebugStruct);

const defaultDebugState = {
  empty: false,
  skeleton: false,
  error: false,
  markup: false,
  fetching: false,
  query: false,
};

export const DebugProvider = ({ children }: IDebugProvider) => {
  const [presentAlert] = useIonAlert();
  const [debugState, setDebugState] =
    useState<DebugStateStruct>(defaultDebugState);

  const handlerAction = async () => {
    await presentAlert({
      header: 'Debug mode',
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
        },
        {
          text: 'Skeleton',
          role: 'skeleton',
        },
        {
          text: 'Fetching state',
          role: 'fetching',
        },
        {
          text: 'Empty state',
          role: 'empty',
        },
        {
          text: 'Error state',
          role: 'error',
        },
        {
          text: 'Markup highlight',
          role: 'markup',
        },
        {
          text: 'React-query dev tool',
          role: 'query',
        },
      ],
      onDidDismiss: (e: CustomEvent) => {
        const role: roleType = e.detail.role;
        if (role === 'cancel') {
          setDebugState({
            ...defaultDebugState,
          });
        } else {
          setDebugState({
            ...defaultDebugState,
            [role]: !debugState[role],
          });
        }
      },
    });
  };

  useEffect(() => {
    const handler = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.key === 'd') {
        handlerAction();
      }
    };
    window.addEventListener('keydown', handler, false);
    return () => {
      window.removeEventListener('keydown', handler, false);
    };
  }, [handlerAction]);

  return (
    <DebugContext.Provider value={debugState}>{children}</DebugContext.Provider>
  );
};
